import { Route } from '@angular/router';
import { PlaybookComponent } from './playbook.component';

/**
Admin Segregation - Create script for inserting new page into segregation.
Example : INSERT INTO sys_MenuLinkInfo ([Key], [Url],[GroupId], [Label])
VALUES ('21.6', 'security/certificate-management',21, 'xmlCertificateManagement')
GO
*/
export const ROUTES: Route[] = [
  {
    path: 'playbook',
    component: PlaybookComponent,
    data: { title: 'Playbook' },
  }
]
